export default "__VITE_ASSET__BkT$vLoM__"